/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Attributes_IncompleteInputs */

const en_error_attributes_incomplete = /** @type {(inputs: Error_Attributes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some SKUs still miss required attributes. Fill them in and send again.`)
};

/**
* | output |
* | --- |
* | "Some SKUs still miss required attributes. Fill them in and send again." |
*
* @param {Error_Attributes_IncompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_attributes_incomplete = /** @type {((inputs?: Error_Attributes_IncompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Attributes_IncompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_attributes_incomplete(inputs)
});